export function formatValue(value: string | number, fractionDigits?: number): string | number {
  const parsedValue = parseFloat(value as string);

  if (!Number.isNaN(parsedValue) && Number.isFinite(parsedValue)) {
    if (Number.isInteger(parsedValue)) {
      return parsedValue.toLocaleString('pt-BR', {
        minimumFractionDigits: fractionDigits || 0,
      });
    }

    return parsedValue.toLocaleString('pt-BR', {
      maximumFractionDigits: fractionDigits,
    });
  }
  return value;
}
